import React  from 'react';

interface Props {
    defaultValue?: string | boolean,
    id?: any,
    onSubmit: Function,
    inputType?: string,
    enabledProductPermission?:boolean
}

interface State {
    value?: string | boolean,
    inputValue?: string | boolean
}

export class UserBlocked extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: props.defaultValue, inputValue: props.defaultValue};
    }

    handleChange(event: any) {
        let value = this.props.inputType === "checkbox" ? event.currentTarget.checked : event.currentTarget.value;
        this.setState({ inputValue: value });
        this.props.onSubmit(value);
    }

    render() {
        let inputType = this.props.inputType || "text";
        let ramd: any = Math.random().toString(36).substring(7)
        let id: any = this.props.id || ramd;
        let checked : any = this.props.defaultValue;
        return (
            <div className='custom-control custom-switch'>
                <span>
                    <input
                        type='checkbox'
                        className='custom-control-input'
                        id={id}
                        defaultValue={inputType !== "checkbox" ? this.props.defaultValue + "" : undefined}
                        checked={checked ? true : false}
                        onChange={e => this.handleChange(e)}
                        autoFocus onFocus={e => e.currentTarget.select()}
                        disabled={this.props.enabledProductPermission === false ? true : false}
                    />
                    <label className='custom-control-label' htmlFor={id}></label>
                </span>
            </div>
        );  
    }
}
